"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var buttons_1 = require("../buttons");
var theme_1 = require("../../theme");
var TabGroup = function (_a) {
    var branding = _a.branding, buttonClassName = _a.buttonClassName, className = _a.className, currentTabId = _a.currentTabId, labelClassName = _a.labelClassName, onClick = _a.onClick, tabs = _a.tabs, _b = _a.alignment, alignment = _b === void 0 ? 'stretch' : _b, _c = _a.inActiveTextColor, inActiveTextColor = _c === void 0 ? 'weaker' : _c, _d = _a["data-testid"], dataTestId = _d === void 0 ? 'tabGroup-container' : _d;
    var borderColors = (0, theme_1.useBorderColors)(branding);
    return ((0, jsx_runtime_1.jsx)("section", __assign({ className: (0, classnames_1.default)('squid-flex squid-overflow-auto squid-w-auto squid-border-b', borderColors.base, {
            'squid-justify-between': alignment === 'stretch',
            'squid-justify-start': alignment === 'left',
            'squid-justify-end': alignment === 'right',
            'squid-gap-6': alignment !== 'stretch',
        }, className), "data-testid": dataTestId }, { children: tabs.map(function (tab) {
            var _a;
            var isSelected = tab.id === currentTabId;
            return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)('squid-whitespace-nowrap', {
                    'squid-flex-grow': alignment === 'stretch',
                }) }, { children: [(0, jsx_runtime_1.jsx)(buttons_1.SimpleButton, { className: (0, classnames_1.default)('[&]:squid-bg-transparent', '[&]:focus:squid-ring-0', '[&]:focus:squid-ring-offset-0', '[&]:squid-rounded-none', '[&]:squid-border-none', '[&]:squid-px-4', '[&]:md:squid-px-2', 'squid-h-10', 'squid-w-full', buttonClassName), titleClassName: (0, classnames_1.default)('squid-text-center', labelClassName), active: isSelected, "data-testid": tab['data-testid'] || "tabGroupTab-".concat(tab.id), onClick: function () { return onClick(tab.id); }, title: tab.label, branding: branding, variant: "outlined", leftIcon: tab.leftIcon, rightIcon: tab.rightIcon, strong: true, textColor: !isSelected ? inActiveTextColor : undefined }, tab.id), (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)('squid-h-px', 'squid-border-b-2', 'squid-w-auto', (_a = {},
                            _a[borderColors.active] = isSelected,
                            _a[borderColors.transparent] = !isSelected,
                            _a)) })] }), tab.id));
        }) })));
};
exports.TabGroup = TabGroup;
